import React from "react";
import { FaArrowRight } from "react-icons/fa6";

const dashboardCard = ({ icon, title, content, link, url }) => {
  const cardStyle = {
    boxShadow: "0px 0px 8px rgba(44, 99, 152, 0.12)",
  };

  const resetPageState = () => {
    localStorage.removeItem("isDriverOrder");
  };

  return (
    <div
      className="flex items-start bg-blue-400 hover:bg-light-blue rounded-[20px] border-l-[5px] border-transparent hover:border-blue-200 ease-in duration-300 group"
      style={cardStyle}
    >
      <a
        href={url}
        onClick={resetPageState}
        className="flex items-center gap-4 3xl:gap-5 w-full py-4 3xl:py-5 px-4 3xl:px-5"
      >
        <div className="flex-shrink-0 bg-blue-300 p-3 3xl:p-3.5 rounded-full">
          <img src={icon} className="" />
        </div>
        <div className="flex-1 min-w-0">
          <h3 className="text-4xl xl:text-3xl 3xl:text-4xl font-robotoBold text-gray-600 truncate">
            {title}
          </h3>
        </div>
      </a>
    </div>
  );
};

export default dashboardCard;
